"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const experiments_1 = require("../constants/experiments");
const storageMechanism_1 = require("../constants/storageMechanism");
exports.default = (experimentGoal, experimentName, storageMechanism) => {
    if (storageMechanism === storageMechanism_1.StorageMechanism.LocalStorage) {
        try {
            window.localStorage.removeItem(`${experiments_1.PREFIX}::${experimentGoal}::${experimentName}`);
        }
        catch (e) {
            // Do nothing - error is thrown if experimentName does not exist
        }
    }
};
//# sourceMappingURL=deleteExperiment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/experiments/deleteExperiment.js
// module id = myXO
// module chunks = 55